import { createFileRoute } from '@tanstack/react-router';
import api from '@/api';
import { ArticleDetailScreen } from '@/common/ArticleDetailScreen';
import { kindForRole, toArticleDetail } from '@/posts/posts';
import { useCurrentUser } from '~/hooks/useCurrentUser';

export const Route = createFileRoute('/_app/study-helper-tutorials/$slug')({
  component: TutorialDetailScreen,
});

function TutorialDetailScreen() {
  const { slug } = Route.useParams();
  const { me, isStudyHelper, isPending: isUserPending } = useCurrentUser();
  // The kind depends on the viewer's role, so hold the request until the role is
  // known — guessing "student" 404s for a study helper and caches the failure.
  // Language is sent because translations share a slug: this route is reached
  // from the viewer's own feed, so they want their language's article.
  const { data, isPending } = api.getPost.useQuery(
    {
      path: { slug },
      query: {
        kind: kindForRole(isStudyHelper, 'tutorials'),
        language: me?.language ?? 'EN',
      },
    },
    { enabled: !isUserPending },
  );
  const article = data ? toArticleDetail(data) : undefined;

  return (
    <ArticleDetailScreen
      article={article}
      // A gated-off query still reports `isPending`, so this covers both waits.
      isLoading={isPending}
      backPath="/tutorials"
      // Translation Needed
      notFoundMessage="Tutorial not found"
      showDate={false}
    />
  );
}
